import React from 'react';
import "./add-language-wizard-stepper.scss";

interface IProps {
    activeStepIndex: number;
    totalSteps: number;
}

const AddLanguageWizardStepper: React.FC<IProps> = ({ totalSteps, activeStepIndex }) => (
    <ul className="add-language-wizard-stepper">
        {Array.from({ length: totalSteps }).map((_, index) => (
            <li
                className={"add-language-wizard-stepper-item " + (index === activeStepIndex && 'is-active')}
                key={`add-language-wizard-stepper-${index}`}
            />
        ))}
    </ul>
);

export default AddLanguageWizardStepper;